import React from 'react';
import PropTypes from 'prop-types';
import Component from 'BaseComponent';
import Spinner from 'components/Spinner';
import PdfDownload from 'components/PdfDownload';
import api from 'api';
import { query } from 'redux-bees';
import { FormattedDate } from 'react-intl';
import capitalize from 'capitalize';

@query('invoices', api.getInvoices)

export default class Account extends Component {
  static propTypes = {
    status: PropTypes.object.isRequired,
    invoices: PropTypes.array,
  }

  renderInvoice(invoice) {
    return (
      <tr key={invoice.id}>
        <td>{invoice.id}</td>
        <td>
          <FormattedDate
            value={Date.parse(invoice.attributes.date)}
          />
        </td>
        <td>
          € {invoice.attributes.total / 100}
        </td>
        <td>
          {capitalize.words(invoice.attributes.status)}
        </td>
        <td className="table__cell--right">
          <PdfDownload id={invoice.id} />
        </td>
      </tr>
    );
  }

  render() {
    const { status, invoices } = this.props;

    return (
      <div>
        {
          status.invoices.isLoading &&
            <div className="spinner-container">
              <Spinner size={40} />
            </div>
        }
        {
          invoices &&
            <div>
              <table className="table">
                <thead>
                  <tr>
                    <th>
                      Invoice #
                    </th>
                    <th>
                      Invoice date
                    </th>
                    <th>
                      Amount
                    </th>
                    <th>
                      Status
                    </th>
                    <th />
                  </tr>
                </thead>
                <tbody>
                  {invoices.map(this.renderInvoice.bind(this))}
                </tbody>
              </table>
              {
                invoices.length === 0 &&
                  <div className="table__empty">
                    No invoice has been generated for this billing profile yet.
                  </div>
              }
            </div>
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/Invoices.jsx